import React, { Fragment } from "react";

import { bool, func, string } from "prop-types";

import { InputFile, Overlay, Loading } from "../../common";

import { isMobile } from "../../helpers";

const ImageInput = ({
  imageKey,
  loading,
  handleChange,
  title,
  description,
  showHeader,
  text,
  isDnata = false,
  isABM = false,
  isUploaded,
  allowPdf = false,
}) => (
  <div>
    <Overlay show={loading}>
      <Loading />
    </Overlay>
    {showHeader && (
      <div className="col-12 text-center d-none d-md-block">
        <h4>{title}</h4>
        <p className="text-lightGrey">{description}</p>
      </div>
    )}
    <div className="col-12 py-2">
      <div>
        {!isUploaded &&
          (isMobile ? (
            <Fragment>
              <div style={{ display: "flex", justifyContent: "center" }}>
                {!isDnata && !isABM && (
                  <InputFile
                    name={imageKey}
                    onChangeHandler={handleChange}
                    acceptMimeTypes={`.jpg,.jpeg,.png,.bmp,.tiff${
                      allowPdf ? ",.pdf" : ""
                    }`}
                    classes="m-auto btn btn-block btn-info cursor-pointer mb-0"
                    containerStyle={{ marginRight: 8 }}
                    idName={`profileImageFromCamera_${imageKey}`}
                    text="Camera"
                    isCamera
                  />
                )}
                <InputFile
                  name={imageKey}
                  onChangeHandler={handleChange}
                  acceptMimeTypes={`.jpg,.jpeg,.png,.bmp,.tiff${
                    allowPdf ? ",.pdf" : ""
                  }`}
                  classes="m-auto btn btn-block btn-info cursor-pointer mb-0"
                  idName={`profileImage_${imageKey}`}
                  text={text}
                />
              </div>
            </Fragment>
          ) : (
            <InputFile
              onChangeHandler={handleChange}
              acceptMimeTypes={`.jpg,.jpeg,.png,.bmp,.tiff${
                allowPdf ? ",.pdf" : ""
              }`}
              classes="m-auto btn btn-block btn-info cursor-pointer mb-0"
              styles={{ width: 264 }}
              idName={`profileImage_${imageKey}`}
              name={imageKey}
              text={text}
            />
          ))}
      </div>
    </div>
  </div>
);

ImageInput.propTypes = {
  imageKey: string.isRequired,
  loading: bool.isRequired,
  title: string.isRequired,
  description: string.isRequired,
  handleChange: func.isRequired,
  showHeader: bool,
  text: string,
  isDnata: bool,
  isABM: bool,
  isUploaded: bool,
  allowPdf: bool,
};

export default ImageInput;
